import { specieIconFromId } from '../utilities/utils';
import { loadReport, loadPurchaseOrder } from '../utilities/httpRequest';
import { useNavigate } from 'react-router-dom';
import ImageRoundButton from './ImageRoundButton';
import classNames from 'classnames';

export default function ResultLabel({ order, species }) {

    const navigate = useNavigate();

    const Animal = ({ name, id }) => {
        return (
            <div className="flex flex-row items-center gap-2 px-2">
                <img className="h-10" alt="specie-icon" src={specieIconFromId(id, species)}></img>
                <p className="text-dark-green font-medium">{name}</p>
            </div>
        );
    }

    const borderColor= {
        borderColor: order.global_status.color
    }

    return (
        <div className="flex flex-row h-14 bg-white rounded-2xl shadow justify-between items-center px-3">
            <div className="flex flex-col">
                <p className="text-dark-green font-medium">{order.owner.first_name} {order.owner.last_name}</p>
                <p className="text-dark-green font-medium text-xs">{order.created_at}</p>
            </div>
                {order.animals.map((item) => <Animal key={item.name} name={item.name} id={item.species} />)}
            <p style={order.global_status.color?borderColor:{}} className={classNames((order.global_status.color?"":"border-dark-green"),"rounded-full border-2 py-1 px-3 font-medium text-dark-green text-md")}>{order.global_status.label}</p>
            <div className="flex flex-row gap-2">
                <ImageRoundButton color="bg-medium-green" onClick={() => loadPurchaseOrder(order.id, navigate)} alt="purchase-order" src="./iconslimsvet/purchase_order.svg" title="Prescription" />
                <ImageRoundButton color="bg-medium-green" onClick={() => loadReport(order.id, navigate)} alt="report" src="./iconslimsvet/report.svg" title="Compte rendu" />
            </div>
        </div>
    );
}

